module.exports = __webpack_public_path__ + "images/assets/c727d1d32ce0ebb57a42e523788647fc.svg";